function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
export var useMenuItems = function useMenuItems() {
  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuItems = _React$useState2[0],
      setMenuItems = _React$useState2[1];

  var register = React.useCallback(function (_ref) {
    var element = _ref.element,
        disabled = _ref.disabled;
    if (!element || disabled) return;
    setMenuItems(function (prevItems) {
      if (prevItems.find(function (item) {
        return item.element === element;
      })) {
        return prevItems;
      } // Returns index of first item in prevItems i.e before element


      var index = prevItems.findIndex(function (item) {
        return (// Returns true when item.element is located before element
          Boolean(item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING)
        );
      });
      var newItem = {
        element: element,
        disabled: !!disabled
      };

      if (index === -1) {
        return [].concat(_toConsumableArray(prevItems), [newItem]);
      }

      return [].concat(_toConsumableArray(prevItems.slice(0, index)), [newItem], _toConsumableArray(prevItems.slice(index)));
    });
  }, []);
  var unregister = React.useCallback(function (element) {
    if (!element) return;
    setMenuItems(function (menuItems) {
      return menuItems.filter(function (item) {
        return element !== item.element;
      });
    });
  }, []);
  return {
    register: register,
    unregister: unregister,
    menuItems: menuItems
  };
};